<template>
  <div class="wgtSettings" :class="{ 'isTableShown': isShowTable }">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="tiersnap">
          <div class="content-panel1" v-show="IsTierErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ tierheader }}</h2>
            <apiErrorComponent @tryReload="tryReload" :compTitle="tierheader" compId="tiersnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IsTierErr">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IsTierErr">
                  <font-awesome-icon icon="fa-solid fa-diagram-successor" title="Switch to Alternate View"
                    v-on:click="swapCharts()" />
                  <font-awesome-icon icon="fa-solid fa-table" v-on:click="showTable()"
                    :title="isShowTable ? 'Hide Table' : 'Show Table'" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.Tier_overall }} You can click on individual slices to get more
                insights.<br /><br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-diagram-successor" /> to
                    swap between bar and pie chart view
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-table" /> to see table with
                    values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to
                    storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart
                    with current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download
                    all the
                    insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isLoadTier">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isLoadTier"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ tierheader }}</h2>
            <div class="panel-body text-center" :class="{ 'BlurClass': !isLoadTier }">
              <div class="chartHeightControl" id="tierChart">
              </div>
              <div v-if="isShowTable">
                <div v-on:click="onBtnExport()" class="myfaBtn spl">
                  <font-awesome-icon :icon="['fas', 'fa-download']" />
                </div>
                <ag-grid-vue style="width: 96%;height:470px;"
                  class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="asgcolsDefs"
                  @grid-ready="onAsgReady" :modules="modules">
                </ag-grid-vue>
              </div>
              <div v-if="IsTierdata" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
            <widgetsSlider :insideArr="tierinsight" :isInsErr="IsTrInsErr" :isErr="IsTierErr" :compTitle="tierheader"
              compId="tiersnap"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import {
  ClientSideRowModelModule
} from "@ag-grid-community/client-side-row-model";
import {
  CsvExportModule
} from "@ag-grid-community/csv-export";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue'
import widgetsSlider from '../smallcomp/widgets-slider.vue';
var myChartTier
function reportWindowSizeTier() {
  if (myChartTier != undefined) {
    myChartTier.resize()
  }
}
export default {
  name: 'TierView',
  mixins: [screenShotMix],
  components: {
    widgetLoadingComp,
    widgetDataMsg,
    AgGridVue,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      modules: [ClientSideRowModelModule, CsvExportModule],
      asgLisApi: null,
      asgLis: null,
      asgcolsDefs: [],
      isShowTable: false,
      isLoadTier: false,
      Istiershow: false,
      IsTierdata: false,
      IsTrInsErr: false,
      IsTierErr: false,
      isPieshow: true,
      tierheader: "",
      tierinsight: [],
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      tierchartresp: {},
      isChartRedraw: true,
    }
  },
  methods: {
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      this.getTierBreakdown(this.getwgtCond)
    },
    addToSlider() {
      let insArr = this.tierinsight;
      let name = "Tier Analysis - " + this.getPins.viewName;
      let screenShort = {
        id: 'tiersnap',
        name: 'tiersnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    onAsgReady(params) {
      this.asgLisApi = params.api
      this.gridColumnApi = params.columnApi
      this.asgLisApi.setRowData(this.asgLis);
      params.api.sizeColumnsToFit();
    },
    onBtnExport() {
      this.asgLisApi.exportDataAsCsv();
    },
    percGetter(params) {
      return params.data.Percentage + '%'
    },
    myPercComparator(v1, v2, n1, n2) {
      v1 = parseFloat(v1.slice(0, -1))
      v2 = parseFloat(v2.slice(0, -1))
      return v1 - v2
    },
    numberValueFormatter(params) {
      return params.data.Count.toLocaleString();
    },
    showTable() {
      if (this.isShowTable) {
        this.isShowTable = false
      } else {
        this.asgcolsDefs = [{
          headerName: 'Tier',
          field: 'Tier',
          sortable: true
        },
        {
          headerName: '# Tickets',
          field: 'Count',
          type: 'numericColumn',
          valueGetter: this.numberValueFormatter,
          sortable: true
        },
        {
          headerName: 'Percentage',
          field: 'Percentage',
          type: 'numericColumn',
          comparator: this.myPercComparator,
          valueGetter: this.percGetter,
          sortable: true
        }
        ]
        this.isShowTable = true;
      }
    },
    downloadDom() {
      let imgname = "Tier_Breakup_Chart.png"
      let widgetID = "tiersnap"
      var geticondiv = document.querySelectorAll('#tiersnap .insideL,#tiersnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = this.tierheader + '_Insights.txt'
      let insArr
      insArr = this.tierinsight.join("\r\n");
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    drawTier() {
      let emit = this.$emit
      this.asgLis = [];
      var dataT = [];
      for (let index = 0; index < this.tierchartresp.Count.length; index++) {
        this.asgLis.push({
          "Tier": this.tierchartresp.Labels[index],
          "Count": this.tierchartresp.Count[index],
          "Percentage": this.tierchartresp.Perc[index] == 0 ? '<1' : this.tierchartresp.Perc[
            index]
        })
        dataT.push({
          value: this.tierchartresp.Count[index],
          name: this.tierchartresp.Labels[index],
          perc: this.tierchartresp.Perc[index] == 0 ? '<1' : this.tierchartresp.Perc[index]
        })
      }
      var chartDomTT = document.getElementById('tierChart');
      if(chartDomTT == null) return;
      if (chartDomTT != null && chartDomTT != undefined) {
        chartDomTT.style.height = "405px"
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartTier = echarts.init(chartDomTT);
        }
        var option;
        option = {
          tooltip: {
            confine: true,
            formatter: (params) => {
              return params.marker + params.data.name + ": " + params.data.value
                .toLocaleString() + "(" +
                params.data.perc + "%)";
            },
          },
          legend: {
            show: true,
            top: 'bottom',
            textStyle: {
              color: '#777'
            },
            type: 'scroll'
          },
          visualMap: {
            type: 'continuous',
            top: 0,
            text: ['High', 'Low'],
            calculable: true,
            min: 0,
            max: this.tierchartresp.Count[0],
            inRange: {
              color: this.$store.state.chartColor,
            },
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          grid: {
            top: 10,
            bottom: 40,
            left: 120,
            right: 20
          },
          xAxis: {
            show: false,
            data: null,
          },
          yAxis: {
            show: false,
            data: null,
          },
          series: [{
            animationDurationUpdate: 1000,
            universalTransition: true,
            name: '# Tickets',
            type: 'pie',
            radius: ['40%', '70%'],
            label: {
              show: false
            },
            roseType: 'radius',
            itemStyle: {
              borderRadius: 5,
              opacity: 1,
            },
            emphasis: {
              label: {
                show: true
              }
            },
            data: dataT
          }]
        };
        option && myChartTier.setOption(option);
        myChartTier.on('click', function (params) {
          if (params.componentType === 'series') {
            let clickitem = {
              "currpass": params.name,
              "filterop": "SUPPORT_TIER"
            }
            emit("getKDrill", clickitem)
          }
        });
      }
    },
    drawChart() {
      let emit = this.$emit
      let chartDomTT = document.getElementById('wcChart');
      if(chartDomTT == null) return;
      if (chartDomTT != null && chartDomTT != undefined) {
        chartDomTT.style.height = "405px"
        if (myChartTier == undefined) {
          myChartTier = echarts.init(chartDomTT);
        }
        let dataArr = [];
        for (let index = 0; index < this.tierchartresp.Count.length; index++) {
          const element = this.tierchartresp.Count[index];
          dataArr.push({
            value: element,
            perc: this.tierchartresp.Perc[index]
          })
        }
        let option = {
          legend: {
            show: false,
          },
          tooltip: {
            confine: true,
            trigger: 'axis',
            formatter: (params) => {
              return params[0].marker + params[0].axisValue + ": " + params[0].data.value +
                "(" + params[0].data.perc + "%)";
            },
          },
          xAxis: {
            show: true,
            type: 'category',
            data: this.tierchartresp.Labels,
            silent: false,
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              rotate: 30,
              width: 80,
              overflow: 'truncate',
              color: "#777",
              fontSize: 10
            },
          },
          yAxis: {
            show: true,
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              color: "#777",
              fontSize: 10
            },
          },
          series: [{
            type: 'bar',
            itemStyle: {
              borderRadius: 2,
            },
            animationDurationUpdate: 1000,
            universalTransition: true,
            data: dataArr
          }]
        };
        myChartTier.setOption(option);
        myChartTier.on('click', function (params) {
          if (params.componentType === 'series') {
            let clickitem = {
              "currpass": params.name,
              "filterop": "SUPPORT_TIER"
            }
            emit("getKDrill", clickitem)
          }
        });
      }
    },
    swapCharts() {
      this.isPieshow = !this.isPieshow;
      setTimeout(() => {
        if (this.isPieshow) {
          this.drawTier();
        } else {
          this.drawChart();
        }
      }, 500);
    },
    getTierBreakdown(Cond) {
      this.isLoadTier = false
      this.Istiershow = false
      this.IsTierdata = false
      this.IsTrInsErr = false
      this.IsTierErr = false
      if (Cond == 6) {
        this.tierheader = "Converged Layer Breakup"
      } else {
        this.tierheader = "Support Tier Breakup"
      }
      this.axios.post(this.uriApiUrl + "DataAnalysis/get_tierchart?asg_id=" + this.asgId + "&Cond=" + Cond, {
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              this.tierchartresp = response.data
              this.tierinsight = this.tierchartresp.insights
              this.Istiershow = true
              if (this.tierinsight.length == 0) {
                this.IsTrInsErr = true
              }
              if (this.isChartRedraw) {
                try {
                  echarts.dispose(myChartTier);
                } catch (error) {
                  // console.log("..")
                }
              }
              this.drawTier()
            } else if (response.data == "Nodata") {
              this.IsTierdata = true
            } else if (response.data == "Error") {
              this.IsTierErr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Tier Trend. Try after sometime!'
              })
            }
            this.isLoadTier = true
          }
        }).catch((response) => {
          this.IsTierErr = true
          this.isLoadTier = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Tier Trend. Try after sometime!'
            })
          }
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getTierBreakdown(this.getwgtCond)
    this.isChartRedraw = true
    window.addEventListener("resize", reportWindowSizeTier);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeTier);
  },
  computed: {
    getwgtCond() {
      return this.$store.state.widgetCond
    },
    getgradGreen() {
      return this.$store.getters.getgradGreen
    },
    getgradRed() {
      return this.$store.getters.getgradRed
    },
    getgradOrange() {
      return this.$store.getters.getgradOrange
    },
    getgradYellow() {
      return this.$store.getters.getgradYellow
    },
    getgradCyan() {
      return this.$store.getters.getgradCyan
    },
    getgradBlue() {
      return this.$store.getters.getgradBlue
    },
    getgradPurple() {
      return this.$store.getters.getgradPurple
    },
    getgradOceanBlue() {
      return this.$store.getters.getgradOceanBlue
    },
    getgradSandal() {
      return this.$store.getters.getgradSandal
    },
    getgradBrown() {
      return this.$store.getters.getgradBrown
    },
    getgradViolet() {
      return this.$store.getters.getgradViolet
    },
  },
  watch: {
    '$store.state.chartColor': function () {
      if (myChartTier != undefined) {
        this.drawTier()
      }
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->